import React, {useState, useEffect} from 'react'
import useAxios from '../api/axios';
import { useNavigate, useParams} from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth } from '../context/AuthProvider';

export const EditCompany = () => {

    const navigate = useNavigate();
    const {companyID} = useParams();
  
    const [name, setName] = useState('');
    const [invoicingEmail, setInvoicingEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [publicPhone, setPublicPhone] = useState('');
    const [publicEmail, setPublicEmail] = useState('');
    const [address, setAddress] = useState('');
    const [address2, setAddress2] = useState('');
    const [postalcode, setPostalcode] = useState('');
    const [city, setCity] = useState('');
    const [facebook, setFacebook] = useState('');
    const [instagram, setInstagram] = useState('');
    const [description, setDescription] = useState('');
    const [homepage, setHomepage] = useState('');

    const {auth, setAuth} = useAuth();

    

  useEffect(() => {
    auth.companies.filter(comp => comp.companyID === companyID).forEach(comp => {
      setName(comp.name);
      setPublicEmail(comp.publicEmail);
      setInvoicingEmail(comp.invoicingEmail);
      setPhone(comp.phone);
      setPublicPhone(comp.publicPhone);
      setAddress(comp.address);
      setAddress2(comp.address2);
      setPostalcode(comp.postalcode);
      setCity(comp.city);
      setFacebook(comp.facebook);
      setInstagram(comp.instagram);
      setHomepage(comp.homepage);
      setDescription(comp.description);
    })    
    },[]);


    

    const api =useAxios();

    function validateForm() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      let ok = true;

      
      if (!emailRegex.test(invoicingEmail)) {
          toast.error("Tarkista laskutuksen sähköposti osoite");
          ok = false;
      }
      
      if (publicEmail && !emailRegex.test(publicEmail)) {
        toast.error("Tarkista julkinen sähköposti osoite");
        ok = false;
    }

      if(name.trim().length === 0) {
          toast.error("Anna yrityksen, yhdistyksen tai myyjän nimi")
          ok = false;
      }
      
      if(phone.trim().length === 0) {
          toast.error("Anna puhelinumerosi")
          ok = false;
      }

      return ok;
  }

  const handleSubmit = async (e) => {
          e.preventDefault();    
          
          if(!validateForm()) {
              return;
          }
  
          try {

             const editCompany = { companyID, name, phone, invoicingEmail, address, address2, postalcode, city, publicEmail, publicPhone, homepage,facebook, instagram, description};

              const response = await api.post('/editCompany',
                  JSON.stringify({ company: editCompany }),
                  {
                      headers: { 'Content-Type': 'application/json'},                    
                  }
              );
                             
              setAuth( {...auth, companies: auth.companies.map(comp => comp.companyID === companyID ? {...comp, ...editCompany} : comp)});
              toast.info("Tiedot päivitetty");
              navigate(-1);              
          } catch(err) {
              if(!err?.response) {
                  toast.error('Odottomaton virhe ' . err);
                  //setErrMsg("Ei vastausta palvelimelta");
              } else if(err.response?.status === 400) {
                  toast.error("Palvelin virhe");
                  //setErrMsg("Palvelin virhe");
              } else if(err.response?.status === 401) {
                  toast.error("Tunnukset eivät kelpaa");
                  //setErrMsg("Tunnukset eivät kelpaa");
              } else {
                  toast.error("Tietojen päivitys epäonnistui");
                  //setErrMsg("Kirjautuminen epäonnistui");
              }
              //errRef.current.focus();
          }        
      }

      const handleGoBack = () => {
        navigate(-1); // Navigates back to the previous page
      };

  return (
    <div className="mx-auto max-w-4xl px-4 py-8 text-slate-900">
      <div className="mb-6 rounded-3xl border border-slate-200 bg-white p-6 shadow-sm">
        <div className="flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.28em] text-blue-700">Muokkaa yritystä</p>
            <h1 className="mt-2 text-3xl font-black text-slate-900">{name || 'Yrityksen tiedot'}</h1>
            <p className="mt-2 text-sm text-slate-600">(*) pakolliset kentät</p>
          </div>
          <button
            type="button"
            onClick={handleGoBack}
            className="rounded-xl border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 transition hover:border-slate-400"
          >
            Takaisin
          </button>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="rounded-2xl border border-slate-200 bg-white p-5">
          <h2 className="mb-4 text-sm font-bold uppercase tracking-[0.18em] text-slate-500">Laskutustiedot</h2>
          <p className="mb-4 text-xs text-slate-500">Vain järjestäjän käyttöön</p>
          <div className="grid gap-3 md:grid-cols-2">
            <input
              value={name}
              onChange={e => setName(e.target.value)}
              placeholder="Yrityksen / yhdistyksen / myyjän nimi *"
              className="rounded-xl border border-slate-300 px-3 py-2 text-sm outline-none transition focus:border-blue-500 md:col-span-2"
            />
            <input
              value={invoicingEmail}
              onChange={e => setInvoicingEmail(e.target.value)}
              placeholder="Sähköposti (laskutukseen) *"
              type="email"
              className="rounded-xl border border-slate-300 px-3 py-2 text-sm outline-none transition focus:border-blue-500"
            />
            <input
              value={phone}
              onChange={e => setPhone(e.target.value)}
              placeholder="Puhelin *"
              className="rounded-xl border border-slate-300 px-3 py-2 text-sm outline-none transition focus:border-blue-500"
            />
            <input
              value={address}
              onChange={e => setAddress(e.target.value)}
              placeholder="Katuosoite"
              className="rounded-xl border border-slate-300 px-3 py-2 text-sm outline-none transition focus:border-blue-500 md:col-span-2"
            />
            <input
              value={address2}
              onChange={e => setAddress2(e.target.value)}
              placeholder="Katuosoite 2"
              className="rounded-xl border border-slate-300 px-3 py-2 text-sm outline-none transition focus:border-blue-500 md:col-span-2"
            />
            <input
              value={postalcode}
              onChange={e => setPostalcode(e.target.value)}
              placeholder="Postinumero"
              className="rounded-xl border border-slate-300 px-3 py-2 text-sm outline-none transition focus:border-blue-500"
            />
            <input
              value={city}
              onChange={e => setCity(e.target.value)}
              placeholder="Toimipaikka"
              className="rounded-xl border border-slate-300 px-3 py-2 text-sm outline-none transition focus:border-blue-500"
            />
          </div>
        </div>

        <div className="rounded-2xl border border-slate-200 bg-white p-5">
          <h2 className="mb-4 text-sm font-bold uppercase tracking-[0.18em] text-slate-500">Julkiset tiedot</h2>
          <p className="mb-4 text-xs text-slate-500">Kaikkien sivuston kävijöiden nähtävillä, kun paikka on maksettu</p>
          <div className="grid gap-3 md:grid-cols-2">
            <div className="rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-500 md:col-span-2">
              {name || '—'}
            </div>
            <input
              value={publicEmail}
              onChange={e => setPublicEmail(e.target.value)}
              placeholder="Julkinen sähköposti"
              type="email"
              className="rounded-xl border border-slate-300 px-3 py-2 text-sm outline-none transition focus:border-blue-500"
            />
            <input
              value={publicPhone}
              onChange={e => setPublicPhone(e.target.value)}
              placeholder="Julkinen puhelin"
              className="rounded-xl border border-slate-300 px-3 py-2 text-sm outline-none transition focus:border-blue-500"
            />
            <input
              value={homepage}
              onChange={e => setHomepage(e.target.value)}
              placeholder="Kotisivut"
              className="rounded-xl border border-slate-300 px-3 py-2 text-sm outline-none transition focus:border-blue-500 md:col-span-2"
            />
            <input
              value={facebook}
              onChange={e => setFacebook(e.target.value)}
              placeholder="Facebook"
              className="rounded-xl border border-slate-300 px-3 py-2 text-sm outline-none transition focus:border-blue-500"
            />
            <input
              value={instagram}
              onChange={e => setInstagram(e.target.value)}
              placeholder="Instagram"
              className="rounded-xl border border-slate-300 px-3 py-2 text-sm outline-none transition focus:border-blue-500"
            />
            <textarea
              value={description}
              onChange={e => setDescription(e.target.value)}
              placeholder="Kuvaus, myytävät tuotteet tms."
              rows={4}
              className="rounded-xl border border-slate-300 px-3 py-2 text-sm outline-none transition focus:border-blue-500 md:col-span-2"
            />
          </div>
        </div>

        <div className="flex justify-end gap-3 pb-6">
          <button
            type="button"
            onClick={handleGoBack}
            className="rounded-xl border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 transition hover:border-slate-400"
          >
            Peruuta
          </button>
          <button
            type="submit"
            className="rounded-xl border border-blue-200 bg-blue-50 px-4 py-2 text-sm font-semibold text-blue-700 transition hover:border-blue-300 hover:bg-blue-100"
          >
            Tallenna muutokset
          </button>
        </div>
      </form>
    </div>
  )
}
